var rmUtil = require("../rmlibrary_old/util");
var StyleManager = require("../style-manager");
var PDFNode = require("./node");
var PDFBlockNode = require("./block");
function PDFColumnsNode(tagName, pseudo, parent, content, styles, attributes) {
    PDFNode.apply(this, arguments);
    if (!attributes.columns && !styles["-rm-pdf-columns"])
        throw new TypeError("<pdf-columns> elements must have a columns attribute or a '-rm-pdf-columns' style.");
    if (styles["-rm-pdf-columns"]) {
        this.columns = StyleManager.getColumnWidths(styles["-rm-pdf-columns"]);
    }
    else {
        this.columns = StyleManager.getColumnWidths(attributes.columns);
    }
}
rmUtil.inherits(PDFColumnsNode, PDFNode);
PDFColumnsNode.prototype.setChildren = function (children) {
    this.children = children.filter(function (child) {
        return child instanceof PDFBlockNode;
    });
};
PDFColumnsNode.prototype.generate = function (pdf) {
    var columns = this.columns.map(function (obj) {
        if (obj.unit === "pt")
            return obj.value;
        if (obj.unit === "px")
            return StyleManager.pxToPt(obj.value);
        if (obj.unit === "pct")
            return obj.value / 100;
        return obj;
    });
    return pdf.columns({ columns: columns }, this.children.map(function (child) {
        return child.generate(pdf);
    }));
};
module.exports = PDFColumnsNode;
//# sourceMappingURL=module.js.map